import { AppIcon } from "~/components/app-icon";
import { BoardBar } from "~/components/inside/sheets";
import * as m from "~/paraglide/messages.js";

/**
 * The services hero's exhibit: the client's own sources at the top, one system
 * in the middle, prepared work at the bottom — and a line saying a person still
 * reviews it.
 *
 * Page-local rather than part of the shared sheet vocabulary: nothing else in
 * the site shows a whole system at once, and every other page shows one step of
 * it instead.
 */
export function FlowBoard() {
  return (
    <div aria-label={m.services_flow_label()} className="flow-board" role="img">
      <BoardBar
        mark
        marker={m.services_flow_marker()}
        title={m.services_flow_bar()}
      />

      <div className="board-body">
        <div className="source-chips">
          <span>
            <AppIcon name="gmail" /> {m.services_flow_chip_1()}
          </span>
          <span>
            <AppIcon name="notion" /> {m.services_flow_chip_2()}
          </span>
          <span>
            <AppIcon name="hubspot" /> {m.services_flow_chip_3()}
          </span>
        </div>

        <div aria-hidden="true" className="flow-down">
          ↓
        </div>

        <div className="engine">
          <img alt="" height={43} src="/images/icon.svg" width={43} />
          <div>
            <strong>{m.services_flow_engine_title()}</strong>
            <p>{m.services_flow_engine_body()}</p>
          </div>
        </div>

        <div aria-hidden="true" className="flow-down">
          ↓
        </div>

        <div className="output-list">
          <div>
            {m.services_flow_out_1()} <em>{m.services_flow_out_state()}</em>
          </div>
          <div>
            {m.services_flow_out_2()} <em>{m.services_flow_out_state()}</em>
          </div>
          <div>
            {m.services_flow_out_3()} <em>{m.services_flow_out_state()}</em>
          </div>
        </div>

        <p className="small-note">{m.services_flow_note()}</p>
      </div>
    </div>
  );
}
